import React,{useState} from 'react';
import './App.css';
import Int from './components/input';
import axios from 'axios';
import Result from './components/Result';

function App() {
  const [input,setInput]=useState(""); 
  const [temp,setTemp]=useState(""); 
  const [disc,setDisc]=useState(""); 
  const [icon,setIcon]=useState(""); 


  const findweather= async()=>{
    const api="7d3d0066ed69fb84e987017efbf28086";
    const unit="metric";
    const url="https://api.openweathermap.org/data/2.5/weather?q="+input+"&appid="+api+"&units="+unit;
    const response= await axios.get(url);
    const temp=await response.data.main.temp;
    const disc=await response.data.weather[0].description;
    const icon=await response.data.weather[0].icon;
    const impageUrl="https://openweathermap.org/img/wn/"+icon+"@2x.png";
    setTemp(temp);
    setDisc(disc);
    setIcon(impageUrl);
    setInput("");
  }
  return (
    <div className="app">
      {temp ===""?
       <Int input={input} setInput={setInput} findweather={findweather}/>:
       <Result temp={temp} desc={disc} icon={icon} setTemp={setTemp}/>}
    </div>
  );
};

export default App;
